import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import loadCurrentPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadCurrentPromotions";
import loadPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadPromotions";
import {
    getCurrentPromotionsDataView,
    getPromotionsDataView,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import {
    chain,
    LoadData,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/LoadDataIfNeeded";
import { checkoutOption, dispatchCheckoutEvent } from "@store/Services/AnalyticsService";

replaceInChain(chain, LoadData, props => {
    const state = props.getState();
    if (!getCurrentCountries(state)) {
        props.dispatch(loadCurrentCountries());
    }
    if (props.parameter.cartId) {
        const cartState = getCartState(state, props.parameter.cartId);
        if (!cartState.value && !cartState.isLoading) {
            props.dispatch(loadCart({ cartId: props.parameter.cartId }));
        }
        if (!getPromotionsDataView(state, props.parameter.cartId).value) {
            props.dispatch(loadPromotions({ cartId: props.parameter.cartId }));
        }

        dispatchCheckoutEvent(2, checkoutOption.reviewOrder, cartState.value!);
    } else {
        const currentCartState = getCurrentCartState(state);
        if (
            (!currentCartState.value ||
                (props.parameter.cartLinesShouldBeExpanded &&
                    ((currentCartState.value.lineCount && !currentCartState.value.cartLines) ||
                        !currentCartState.value.carriers))) &&
            !currentCartState.isLoading
        ) {
            props.dispatch(loadCurrentCart());
        }
        if (!getCurrentPromotionsDataView(state).value) {
            props.dispatch(loadCurrentPromotions());
        }
        dispatchCheckoutEvent(2, checkoutOption.reviewOrder, currentCartState.value!);
    }
});
